import { Select } from "antd";
import { type FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import type { User } from "../../../../core/types/fe/entities/user";
import type { PropertyTableSelector } from "../../types/types";
import { fetchUsers } from "./fetchMSEUsers";

interface UserSelectorProps extends PropertyTableSelector {
    onUserSelect: (user: User[]) => void;
    initialUsers: string[];
}

export const MSEUserSelector: FC<UserSelectorProps> = ({ onUserSelect, initialUsers }) => {
    const [users, setUsers] = useState<User[]>([]);
    const [selectedUsers, setSelectedUsers] = useState<string[]>(initialUsers);
    const [loading, setLoading] = useState<boolean>(true);
    const { t } = useTranslation();

    useEffect(() => {
        async function loadUsers() {
            try {
                const userList = await fetchUsers();
                setUsers(userList);
            } finally {
                setLoading(false);
            }
        }
        loadUsers();
    }, []);

    useEffect(() => {
        setSelectedUsers(initialUsers);
    }, [initialUsers]);

    const handleSelectionChange = (values: string[]) => {
        setSelectedUsers(values);
        const selectedUserObjects = users.filter((user) => values.includes(user.userId));
        onUserSelect(selectedUserObjects);
    };

    return (
        <div data-name="mse_user_selector">
            <Select
                mode="multiple"
                loading={loading}
                options={users.map((user) => ({
                    value: user.userId,
                    label: `${user.firstName} ${user.lastName} (${user.username})`,
                }))}
                value={selectedUsers}
                placeholder={t("dataGroups.usersTable.placeholder")}
                onChange={handleSelectionChange}
                filterOption={(input, option) => {
                    if (!option || !option.label) return false;
                    return option.label.toLowerCase().includes(input.toLowerCase());
                }}
                showSearch
            />
        </div>
    );
};
